/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import { withStyles } from '@mui/styles';
import { makeStyles } from '@mui/styles';

import { connect } from 'react-redux';
import { compose } from 'redux';
import MainInfoHeader from './mainInfoHeader';
import CompanyServiceGeneral from './CompanyServiceGeneral';
import Aboutus from './aboutus';
import YtVideo from './ytVideo';


const styles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  CardActions: {
    padding: '10px',
    "&:hover + $toggledElement": {
      backgroundColor: "black",
      display: "block"
    }
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  imageDescp: {
    width: '65%;',
    padding: '1%',
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  imageDotedDescp: {
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {

    backgroundImage: `url(/assets/images/bg/clouds.jpg)`,

    maxHeight: '550px!important',


    position: 'relative',
    zIndex: '9',
    display: 'flex',
    alignItems: 'center',
    height: '100vh',
    padding: '50px 0',
    backgroundSize: 'cover',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    marginTop: '-60px',

    "&::before": {
      content: `''`,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      background: 'linear-gradient(90deg,rgba(3,15,39,.7) 0,rgba(3,15,39,0))'
    }
  },
  container: {

    paddingLeft: '0',
    paddingRight: '0',
    zIndex: '1',
    position: 'relative'
  },
  bigHeaderTypo: {

    fontSize: '72px!important',
    lineHeight: '1.2!important',
    color: '#fff!important',
    marginBottom: '40px!important',
    marginTop: '15%!important'
  },
  bigSubHeaderTypo: {

    fontSize: '20px!important',
    lineHeight: '1.67!important',
    color: '#fff!important',
    marginBottom: '40px!important',
    marginTop: '10px!important',

    fontWeight: '500'
  },
  bigHeaderImg: {
    height: '70px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block'
  },
  bigHeadersubtitle: {
    fontSize: '20px!important',
    color: 'white!important',
    width: 'fit-content'
  },

  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  cardService: {
    position: 'relative',
    display: 'block',
    padding: '10px 60px',
    transition: 'all .25s cubic- bezier(.645, .045, .355, 1)',
    borderRadius: '5px',
    zIndex: '99',
    backgroundColor: '#fff!important',
    "&:hover": {
      transform: 'scale(1.05)',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",

    }

  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    "&:hover": {
      background: '#efefef!important',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",
      borderRadius: '5px'
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },

  cotainerInfoNavigation: {
    marginTop: '100px',
    backgroundColor: '#F5F5F5',


  },

  divinfoNavigation: {

  },
  blocksTypo: {
    textAlign: 'center',
    color: '#383e56',
    paddingTop: '10px'

  },
  blocksTypoInfo: {
    textAlign: 'center',
    color: '#748494',
    paddingTop: '10px',
    fontSize: '20px!important'

  },
  divider: {
    backgroundColor: '#fb743e'
  },
  sectionTitleBorder: {
    width: '50px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',

  },
  IconsDivInfo: {
    fontSize: '2rem',

  },
  IconsDivInfoHolder: {
    width: '80px',
    padding: '20px',
    borderRadius: '50%',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    background: 'white',
    color: '#1c1958',

    "&:hover": {
      background: '#1c1958',
      color: 'white',
      transform: 'rotate(360deg)',
      transition: 'width 2s, height 2s, transform 2s'

    },

  },
  list: {
    color: 'black',
    marginTop: '50px!important'
  },
  subitemIList: {
    lineHeight: '1.7!important',

    "&::before": {
      backgroundColor: '#fb743e !important',
      content: `''`,
      borderRadius: '50%',
      width: '7px',
      height: '7px',
      position: 'absolute',
      left: '0',
      top: '20px'
    },


  },
  cotainerListIfo: {
    backgroundColor: '#f8faff',
    padding: '10px'
  },
  containerWhiteBG: {
    backgroundColor: '#fff!important',
    margin: '2%!important'
  },
  containerDotBG: {
    backgroundColor: '#fff!important',
    backgroundImage: 'radial-gradient(circle, #AE8625  20%, transparent 10%), radial-gradient(circle, #F7EF8A  20%, transparent 10%)',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 0, 50px 50px'
  },
  link: theme.link,
  disabled: theme.disabled,


}));

var cardStyle = {
  display: 'block',
  width: '100%',
  height: '100%',
  backgroundColor: 'transparent',
  border: '1px solid #cbcbcb61'
}

const Home = ({ t }) => {
  const classes = styles();

  return (
    <>
      <main style={{ marginTop: '35px' }}>

        {/* Hero unit */}
        <div>


          <div >
            <MainInfoHeader />

          </div>
          <div id="services" style={{ position: 'relative' }}>
            <CompanyServiceGeneral />
          </div>
          <div id="about" style={{ position: 'relative!important' }}>
            <Aboutus />
          </div>
          
          

        </div>
      </main>



    </>
  );
}

const mapStateToProps = () => {
  return {
    //   loginned: state.loginned
  }
}

const mapDispatchToProps = () => {
  return {

  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
)(Home);